const regionNumbers = {
  "kanto": '2',
  "johto": '7',
  "hoenn": '4',
  "sinnoh": '6',
  "unova": '9',
  "kalos": '12',
  "alola": '16'
}

export default regionNumbers;